module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10214.33fa4a3f.jpg";